/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoProductLogs200ResponseAllOfData } from './GetCostcoProductLogs200ResponseAllOfData';
import {
    GetCostcoProductLogs200ResponseAllOfDataFromJSON,
    GetCostcoProductLogs200ResponseAllOfDataFromJSONTyped,
    GetCostcoProductLogs200ResponseAllOfDataToJSON,
} from './GetCostcoProductLogs200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCostcoProductLogs200ResponseAllOf
 */
export interface GetCostcoProductLogs200ResponseAllOf {
    /**
     * 
     * @type {GetCostcoProductLogs200ResponseAllOfData}
     * @memberof GetCostcoProductLogs200ResponseAllOf
     */
    data: GetCostcoProductLogs200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetCostcoProductLogs200ResponseAllOf interface.
 */
export function instanceOfGetCostcoProductLogs200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCostcoProductLogs200ResponseAllOfFromJSON(json: any): GetCostcoProductLogs200ResponseAllOf {
    return GetCostcoProductLogs200ResponseAllOfFromJSONTyped(json, false);
}

export function GetCostcoProductLogs200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoProductLogs200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCostcoProductLogs200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetCostcoProductLogs200ResponseAllOfToJSON(value?: GetCostcoProductLogs200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoProductLogs200ResponseAllOfDataToJSON(value.data),
    };
}

